module.exports = __webpack_public_path__ + "static/media/Logo.8a3b792e.png";